module.exports = __webpack_public_path__ + "img/Icon-simple-whatsapp.de0391db.svg";